/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { B as index$q } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import showSharePanel$3 from './cn/index.js';
import showSharePanel$4 from './cnStation/index.js';
import showSharePanel$5 from './tbLive/index.js';
import showSharePanel$2 from './nebula/index.js';
import showSharePanel$1 from './dingTalk/index.js';
import showSharePanel$6 from './panguMiniApp/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

/**
 * uni-apis: https://uni-apis.alibaba-inc.com/doc/UI/showsharepanel
 * AP easyShare: https://smallfish.antfin-inc.com/jsapi/easyShare.html
 */
var apiConfig = {
    web: {
        dingTalk: showSharePanel$1,
        nebula: showSharePanel$2,
        windvane: {
            cn: showSharePanel$3,
            cnStation: showSharePanel$4,
            tbLive: showSharePanel$5,
        },
    },
    panguMiniApp: showSharePanel$6,
};
/**
 * 分享功能
 * API：https://yuque.antfin.com/cn-xt/htc47g/tzr9pt
 * @example 使用案例：
 * import { showSharePanel } from '@alife/cn-uni-api'; // h5、小程序通用包
 *
 * showSharePanel({
 *  title: '终于明白为什么大家都爱玩《绿色家园》'
 *  content: '天天领鸡蛋、赚能量，绿色减碳还能赢好礼！',
 *  image: 'https://gw.alicdn.com/imgextra/i4/O1CN010JQ88U1j2T4dMGh4o_!!6000000004490-2-tps-400-400.png',
 *  url: 'https://xxx',
 * })
 *   .then(() => {
 *     console.log('success');
 *   })
 *   .catch((error) => {
 *     console.log(error);
 *   });
 * @author 敬文
 */
var showSharePanel = extend(apiConfig, index$q);

export { showSharePanel };
